import Image from "next/image";
import { cn } from "@/lib/utils";

type SchuetzLogoWhitePropsT = {
  className?: string;
  width?: number;
  height?: number;
};

export function SchuetzLogoWhite({
  className,
  width = 220,
  height = 26,
}: SchuetzLogoWhitePropsT) {
  return (
    <Image
      src="/schuetz_ohne_partner.svg"
      alt="Autohaus Schütz"
      width={width}
      height={height}
      className={cn("block w-auto brightness-0 invert", className)}
    />
  );
}
